

export enum PlotDataSourceType {

    AnalysisInput = "analysis_input",
    CleanedData = "cleaned_data",
    PkResults = "pk_results",
    PkResultsCustomCalcs = "pk_results_custom_calcs"

}